import { showErrorSnackBar, showInfoSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"
import ConsumptionSolutions from "@/components/Projects/Installation/CheckListTab/ConsumptionSolutions.vue"
import { openInstallationsDatabase, deleteInstallationData } from '@/pages/Projects/Utils/IndexedDB.js';
import InstallationService from '@/services/firebase/Installation/InstallationService';
import cloneDeep from 'lodash/cloneDeep';
import InstallationStorage from '@/services/storage/InstallationStorage';
import NextStepProject from "@/components/Projects/NextStepProject.vue"
import UtilsProjects from "@/pages/Projects/Utils/Utils.js";
import ProjectsService from "@/services/server/ProjectsService";
import WaterFixApi from "@/services/apiPdf/WaterFixApi";
import { mapGetters } from "vuex";

export default {
    name: "Prospecção",
    components: {
        ConsumptionSolutions,
        NextStepProject
    },
    props: {
        openModal: {
            type: Boolean,
            default: false
        },
        idProject: {
            type: String,
            default: null
        },
        idInstallation: {
            type: String,
            default: null
        },
        currentStep: {
            type: String,
            default: null
        },
        closeFunc: {
            type: Function,
            default: () => { }
        },
    },
    data: () => ({
        loadingTable: true,
        is_loading: false,
        loading: false,
        loadingMessage: "Carregando dados da instalação...",
        dialog: false,
        id_project: null,
        installationData: [],
        db: null,
        firestoreInstallation: {},
        localStorageData: null,
        existInstallationIndexdDb: false,
        dialogAlert: false,
        savedImages: [],
        dialogStatusDetails: false,
        selectedStatus: null,
        showKpis: true,
        solutionsData: [],
        pointsData: [],
        timelineChart: null,
        messageNextStep: "Finalizar Instalação",
        // Adicionado para revisão
        dialogRevision: false,
        revisionStatus: '',
        revisionObservation: '',
        dialogConfirmDeleteLocal: false,
        dialogConfirmFinish: false,
        disabledButtonNextStep: false,
        readonlyScreen: false,
        choosePdfModal: false,
        pdfDialogDownload: false,
        pdfFileLink: null,
        pdfLoading: false,
        pdfTermOption: 'photo-report',
        pdfTermOptions: [
          {
            name: 'Relatório Fotográfico',
            id: 'photo-report',
            request: WaterFixApi.downloadPhotoReportProject,
          },
          {
            name: 'Relatório de Instalação',
            id: 'installation-term',
            request: WaterFixApi.downloadInstallationTermProject,
          },
        ],
        pdfTermsWithMultipleOptions: ['installation-term', 'photo-report'],
        pdfOptionsByTerms: {
          'photo-report': ['Geral', 'Local'],
          'installation-term': ['Geral', 'Local'],
        },
        pdfChosenOptionByTerm: {
          'photo-report': 'Geral',
          'installation-term': 'Geral',
        },
        pdfChosenLocalByTerm: {
          'photo-report': null,
          'installation-term': null,
        },
        pdfLocals: [],
        project_data: null,
    }),

    computed: {
        ...mapGetters([
            "getCurrentUserRank",
        ]),
        isOline() {
            return navigator.onLine
        },
        statusCounts() {
            if (!this.installationData || this.installationData.length === 0) {
                return {
                    instalado: 0,
                    pendente: 0,
                    naoInstalado: 0,
                    revisado: 0,
                    naoAutorizado: 0,
                    desativado: 0
                }
            }

            const counts = {
                instalado: 0,
                pendente: 0,
                naoInstalado: 0,
                revisado: 0,
                naoAutorizado: 0,
                desativado: 0
            }

            this.installationData.forEach(solution => {
                const status = solution.status || 'Pendente'
                switch (status) {
                    case 'Instalado':
                        counts.instalado++
                        break
                    case 'Pendente':
                        counts.pendente++
                        break
                    case 'Não se Instala':
                        counts.naoInstalado++
                        break
                    case 'Revisado':
                        counts.revisado++
                        break
                    case 'Não Autorizado':
                        counts.naoAutorizado++
                        break
                    case 'Desativado':
                        counts.desativado++
                        break
                    default:
                        counts.pendente++
                        break
                }
            })

            return counts
        },
        totalSolutions() {
            if (!this.installationData) return 0
            return this.installationData.length
        },
        progressPercentage() {
            if (this.totalSolutions === 0) return 0
            return Math.round((this.statusCounts.instalado / this.totalSolutions) * 100)
        },
        instaladoPercentage() {
            return this.progressPercentage
        },
        statusDetailsHeaders() {
            return [
                { text: 'Local', value: 'local', sortable: true },
                { text: 'Sub-local', value: 'sub_local', sortable: true },
                { text: 'Tipo', value: 'type', sortable: true },
                { text: 'Solução', value: 'solution', sortable: true },
                { text: 'Quantidade', value: 'amountSolution', sortable: true },
                { text: 'Comentários', value: 'comments', sortable: false }
            ]
        },
        filteredSolutionsByStatus() {
            if (!this.installationData || !this.selectedStatus) return []
            return this.installationData.filter(solution => solution.status === this.selectedStatus)
        },
        unsavedModifiedCount() {
            if (!this.installationData) return 0
            return this.installationData.filter(solution => solution.isModified).length
        },
        isFranchisee() {
            return this.getCurrentUserRank === "Franqueado"
        },
        diariasUtilizadas() {
            if (!this.installationData || this.installationData.length === 0) return 0
            
            // Filtra soluções com data (qualquer status, pois funcionários precisam ir ao local)
            const solucoesComData = this.installationData.filter(solution => 
                solution.date
            )
            
            if (solucoesComData.length === 0) return 0
            
            // Extrai as datas únicas das visitas
            const datasUnicas = new Set()
            solucoesComData.forEach(solution => {
                if (solution.date) {
                    // Converte para formato YYYY-MM-DD para agrupar por dia
                    const data = new Date(solution.date)
                    const dataFormatada = data.toISOString().split('T')[0]
                    datasUnicas.add(dataFormatada)
                }
            })
            
            return datasUnicas.size
        }
    },

    methods: {
        async addStautsProject(id_project, status, statusAdm = null) {
            await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.INSTALLATION, status, this.currentStep)
            await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.INSTALLATION, statusAdm ? statusAdm : status, this.currentStep, false)
        },
        openObservationDialog(item) {
            this.itensDialog = item
            this.dialog = true
        },
        closeModal() {
            this.is_loading = false
            this.closeFunc('installation')
        },
        async solutionUpdate(solutionList) {
            await this.addEvent(solutionList)
            this.installationData = solutionList
        },
        async processImage(id_doc, data, fileProp, pathProp) {
            try {
                if (data.hasOwnProperty(fileProp)) {
                    if (data[pathProp]) {
                        await InstallationStorage.deleteImg(data[pathProp])
                    }
                    data[pathProp] = null
                    if (data[fileProp]) {
                        data[pathProp] = await InstallationStorage.uploadImg(id_doc, data[fileProp])
                        this.savedImages.unshift({ name: `Imagem ${this.savedImages.length + 1}` })
                    }
                }
                delete data[fileProp]
            } catch (error) {
                console.error(`Error processing image for ${fileProp}:`, error);
            }
        },
        async saveImages(idInstallation, installationData) {
            const processImage = this.processImage
            async function processChecklistItems(items, fileProp, pathProp) {
                for (const key in items) {
                    await processImage(idInstallation, items[key], fileProp, pathProp);
                }
            }
            const checklistMappings = [
                { items: installationData, fileProp: 'file_after', pathProp: 'path_after' },
                { items: installationData, fileProp: 'file_before', pathProp: 'path_before' },
                { items: installationData, fileProp: 'file_extra', pathProp: 'path_extra' },
            ];

            for (const { items, fileProp, pathProp } of checklistMappings) {
                await processChecklistItems(items, fileProp, pathProp);
            }
        },
        async deleteImages(deleteImages) {
            for (const path of deleteImages) {
                await InstallationStorage.deleteImg(path)
            }
        },
        checkModifiedSolutions() {
            return this.installationData.filter((item) => item.isModified)
        },
        
        async saveData(){
            const filterModifiedSolutions = this.checkModifiedSolutions()

                // Só processa se há soluções modificadas
                if (filterModifiedSolutions.length > 0) {
                    let _idInstallation = this.idInstallationLocal
                    if (!_idInstallation) {
                        _idInstallation = await InstallationService.createInstallationDoc(this.idProject)
                        await UtilsProjects.createSuccessLog(this.idProject, UtilsProjects.STEPS.INSTALLATION, "Criado", this.currentStep)
                        await this.addStautsProject(this.idProject, 608, 621)
                    }

                    await this.deleteImages(this.$refs.ConsumptionSolutions.deletedItemsWithPhoto)
                    await this.saveImages(_idInstallation, filterModifiedSolutions)

                    await InstallationService.createInstallationSubCollection(filterModifiedSolutions, _idInstallation)
                    await InstallationService.updateInstallationWithDeleteConsumptionHistoric(_idInstallation)
                    await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.INSTALLATION, "Atualizado", this.currentStep)
                    await this.addStautsProject(this.idProject, 608, 621)
                    showSuccessSnackBar("Waterfix salvo com sucesso!")
                } else {
                    showInfoSnackBar("Sem modificações para salvar!")
                    console.log("No modified solutions to process")
                }

                // Deleta os dados do IndexedDB após salvar com sucesso
                await deleteInstallationData(this.idProject);
        },
        async save(finishInstalattion = false) {
            try {
                if (!this.isOline) {
                    showInfoSnackBar("Você está offline no momento, as informações foram salvas localmente")
                    return
                }
                this.is_loading = true
                await this.saveData()
            } catch (error) {
                showErrorSnackBar("Erro ao Salvar!")
                console.error(error)
            } finally {
                if (finishInstalattion && this.isOline) {
                    if(this.isFranchisee){
                        await this.addStautsProject(this.idProject, 624, 611);
                        await InstallationService.editInstallationProposal(this.idInstallation, {
                            revision: {
                                status: 'reviewSent',
                                observation: ''
                            }
                        })
                        showSuccessSnackBar("Revisão solicitada com sucesso!")
                    }else{
                        await InstallationService.editInstallationProposal(this.idInstallation, {
                            revision: {
                                status: 'approved',
                                observation: ''
                            }
                        })
                        await this.addStautsProject(this.idProject, 623, 610)
                        await UtilsProjects.updateProjectSteps(this.idProject, UtilsProjects.STEPS.FINISH, true, false);
                    }
                }
                setTimeout(() => {
                    this.closeModal();
                }, 4000);
            }
        },
        async saveRevision() {
            // Aqui você pode implementar a lógica de salvar revisão
            this.dialogRevision = false;
            if(this.revisionStatus == 'approved'){
                await this.addStautsProject(this.idProject, 623, 610)
                await InstallationService.editInstallationProposal(this.idInstallation, {
                    revision: {
                        status: this.revisionStatus,
                        observation: this.revisionObservation
                    }
                })
            }else if(this.revisionStatus == 'revision'){
                await InstallationService.editInstallationProposal(this.idInstallation, {
                    revision: {
                        status: "requestedReview",
                        observation: this.revisionObservation
                    }
                })
                await this.addStautsProject(this.idProject, 622, 609)
            }
            showSuccessSnackBar('Revisão salva!');
            this.closeModal();
        },
        cancelGetLocalStorage() {
            this.dialogConfirmDeleteLocal = true;
        },
        confirmDeleteLocal() {
            // Chama o método original para realmente excluir
            this.deleteItemIndexedDB(this.idProject);
            this.dialogAlert = false;
            this.dialogConfirmDeleteLocal = false;
        },
        cancelDeleteLocal() {
            this.dialogConfirmDeleteLocal = false;
        },
        openConfirmFinishDialog() {
            this.dialogConfirmFinish = true;
        },
        confirmFinishInstallation() {
            this.dialogConfirmFinish = false;
            this.save(true);
        },
        dbObject() {
            if (!this.db) {
                throw new Error("Database not initialized");
            }
            try {
                if (!this.db.objectStoreNames.contains('installations')) {
                    this.db.createObjectStore('installations', { keyPath: "id_project", autoIncrement: true });
                }
                const transaction = this.db.transaction("installations", "readwrite");
                return transaction.objectStore("installations");
            } catch (error) {
                console.error("Error accessing database:", error);
                throw error;
            }
        },
        async addEvent(data) {
            this.dbObject().put({ id_project: this.idProject, consumptionHistoric: data, lastUpdateAt: new Date().getTime() });
        },
        async deleteItemIndexedDB(id) {
            this.dbObject().delete(id)
        },
        async checkIndexedDB() {
            if (!this.db) {
                console.error("Database not initialized.");
                return;
            }
            const response = this.dbObject().get(this.idProject)
            response.onsuccess = () => {
                const currentData = response.result;
                if (currentData) {
                    this.localStorageData = currentData;
                    if (this.localStorageData.lastUpdateAt <= this.firestoreInstallation.lastUpdateAt) {
                        this.deleteItemIndexedDB(this.idProject)
                        return
                    }
                    this.dialogAlert = true;
                }
            }

        },
        async getLocalStorage() {
            if (!this.localStorageData) return
            this.installationData = cloneDeep(this.localStorageData.consumptionHistoric);
            this.dialogAlert = false
        },
        async cancelGetLocalStorage() {
            this.deleteItemIndexedDB(this.idProject)
            this.dialogAlert = false
        },
        showStatusDetails(status) {
            this.selectedStatus = status;
            this.dialogStatusDetails = true;
        },
        getStatusColor(status) {
            const colors = {
                'Instalado': 'success',
                'Pendente': 'warning',
                'Não se Instala': 'error',
                'Revisado': 'info',
                'Não Autorizado': 'orange',
                'Desativado': 'grey'
            };
            return colors[status] || 'primary';
        },
        getStatusIcon(status) {
            const icons = {
                'Instalado': 'mdi-check-circle',
                'Pendente': 'mdi-clock',
                'Não se Instala': 'mdi-close-circle',
                'Revisado': 'mdi-eye',
                'Não Autorizado': 'mdi-block-helper',
                'Desativado': 'mdi-power-off'
            };
            return icons[status] || 'mdi-help-circle';
        },
        toggleKpisVisibility() {
            this.showKpis = !this.showKpis;
            // Salva a preferência do usuário no localStorage
            localStorage.setItem('installation_kpis_visible', this.showKpis);
        },
        convertSolutionName(solutionId) {
            if (!solutionId || !this.solutionsData.length) return solutionId;
            
            const solution = this.solutionsData.find(sol => sol.id === solutionId);
            return solution ? solution.solution : solutionId;
        },
        convertNameType(pointId) {
            if (!pointId || !this.pointsData.length) return pointId;
            
            const point = this.pointsData.find(point => point.id === pointId);
            return point ? point.name : pointId;
        },
        async initializeTimelineChart() {
            // Força gráfico de teste (removido o return)
            const testData = {
                labels: ['2023-07-04', '2023-07-05'],
                datasets: [
                    {
                        label: 'Instalado',
                        data: [2, 1],
                        borderColor: '#4CAF50',
                        backgroundColor: 'rgba(76, 175, 80, 0.1)',
                        fill: false
                    }
                ]
            };
            // --- Fim do bloco de teste ---
            // Agora, use os dados reais:
            const realData = this.timelineChartData();
            if (!realData || !realData.labels || !realData.datasets || realData.labels.length === 0) {
                console.warn('timelineChartData está vazio ou mal formatado. Veja o objeto:', realData);
            }
            const ctx = this.$refs.timelineChart;
            if (ctx) {
                if (this.timelineChart) {
                    this.timelineChart.destroy();
                }
                this.timelineChart = new (await import('chart.js')).default(ctx, {
                    type: 'line',
                    data: realData,
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [{
                                type: 'time',
                                time: {
                                    unit: 'day',
                                    displayFormats: {
                                        day: 'DD/MM'
                                    }
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Data'
                                }
                            }],
                            yAxes: [{
                                beginAtZero: true,
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Quantidade de Soluções'
                                }
                            }]
                        },
                        legend: {
                            position: 'top'
                        },
                        tooltips: {
                            mode: 'index',
                            intersect: false
                        }
                    }
                });
            }
        },
        async loadSolutionsData() {
            try {
                // Importa os serviços necessários
                const SolutionsServices = await import('@/services/firebase/SolutionsServices/SolutionsServices.js');
                const SolutionsPoint = await import('@/services/firebase/SolutionsPoint/SolutionsPoint.js');
                
                // Carrega as soluções
                this.solutionsData = await SolutionsServices.default.GetSolutions();
                
                // Carrega os pontos
                let pointIds = this.solutionsData.map((item) => item.type == 'Produto' ? item.pointId : null).filter((item) => item !== null && item !== undefined);
                let response = await SolutionsPoint.default.GetSolutionsPointByIds(pointIds);
                this.pointsData = Object.values(response);
            } catch (error) {
                console.error('Erro ao carregar dados das soluções:', error);
            }
        },
        exportStatusDetails() {
            try {
                const data = this.filteredSolutionsByStatus.map(item => ({
                    Local: item.local,
                    'Sub-local': item.sub_local,
                    Tipo: this.convertNameType(item.type),
                    Solução: this.convertSolutionName(item.solution),
                    Quantidade: item.amountSolution || '-',
                    Comentários: item.comments || '-',
                    Status: item.status
                }));

                const csvContent = this.convertToCSV(data);
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', `soluções_${this.selectedStatus}_${new Date().toISOString().split('T')[0]}.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
                showSuccessSnackBar("Arquivo exportado com sucesso!");
            } catch (error) {
                console.error('Erro ao exportar dados:', error);
                showErrorSnackBar("Erro ao exportar dados");
            }
        },
        convertToCSV(data) {
            const headers = Object.keys(data[0]);
            const csvRows = [headers.join(',')];
            
            for (const row of data) {
                const values = headers.map(header => {
                    const value = row[header];
                    return `"${value}"`;
                });
                csvRows.push(values.join(','));
            }
            
            return csvRows.join('\n');
        },
        getDiariasForStatus() {
            if (!this.filteredSolutionsByStatus || this.filteredSolutionsByStatus.length === 0) return 0
            
            // Filtra soluções com data (qualquer status)
            const solucoesComData = this.filteredSolutionsByStatus.filter(solution => solution.date)
            
            if (solucoesComData.length === 0) return 0
            
            // Extrai as datas únicas das visitas
            const datasUnicas = new Set()
            solucoesComData.forEach(solution => {
                if (solution.date) {
                    const data = new Date(solution.date)
                    const dataFormatada = data.toISOString().split('T')[0]
                    datasUnicas.add(dataFormatada)
                }
            })
            
            return datasUnicas.size
        },
        timelineChartData() {
            // 1. Log do array original
            if (!this.installationData || this.installationData.length === 0) {
                // Força um dataset de teste
                return {
                    labels: ['2023-07-04', '2023-07-05'],
                    datasets: [
                        {
                            label: 'Instalado',
                            data: [2, 1],
                            borderColor: '#4CAF50',
                            backgroundColor: 'rgba(76, 175, 80, 0.1)',
                            fill: false
                        }
                    ]
                }
            }
            // Filtra soluções com data
            const solucoesComData = this.installationData.filter(solution => solution.date)
            // 2. Log do array filtrado
            if (solucoesComData.length === 0) {
                // Força um dataset de teste
                return {
                    labels: ['2023-07-04', '2023-07-05'],
                    datasets: [
                        {
                            label: 'Instalado',
                            data: [2, 1],
                            borderColor: '#4CAF50',
                            backgroundColor: 'rgba(76, 175, 80, 0.1)',
                            fill: false
                        }
                    ]
                }
            }
            // Agrupa por data e status
            const dadosPorData = {}
            solucoesComData.forEach(solution => {
                if (solution.date) {
                    const data = new Date(solution.date)
                    const dataFormatada = data.toISOString().split('T')[0]
                    // Normaliza o status para evitar problemas de acentuação/capitalização e espaços
                    let status = (solution.status || 'Pendente')
                    // 3. Log de cada item processado
                    if (!dadosPorData[dataFormatada]) {
                        dadosPorData[dataFormatada] = {
                            data: dataFormatada,
                            instalado: 0,
                            pendente: 0,
                            naoInstalado: 0,
                            revisado: 0,
                            naoAutorizado: 0,
                            desativado: 0
                        }
                    }
                    switch (status) {
                        case 'Instalado':
                            dadosPorData[dataFormatada].instalado++
                            break
                        case 'Pendente':
                            dadosPorData[dataFormatada].pendente++
                            break
                        case 'Não se Instala':
                            dadosPorData[dataFormatada].naoInstalado++
                            break
                        case 'Revisado':
                            dadosPorData[dataFormatada].revisado++
                            break
                        case 'Não Autorizado':
                            dadosPorData[dataFormatada].naoAutorizado++
                            break
                        case 'Desativado':
                            dadosPorData[dataFormatada].desativado++
                            break
                        default:
                            dadosPorData[dataFormatada].pendente++
                            break
                    }
                }
            })
            // Converte para array e ordena por data
            const dadosOrdenados = Object.values(dadosPorData).sort((a, b) => new Date(a.data) - new Date(b.data))
            const debugData = {
                labels: dadosOrdenados.map(item => item.data),
                datasets: [
                    { label: 'Instalado', data: dadosOrdenados.map(item => item.instalado) },
                    { label: 'Pendente', data: dadosOrdenados.map(item => item.pendente) },
                    { label: 'Não se Instala', data: dadosOrdenados.map(item => item.naoInstalado) },
                    { label: 'Revisado', data: dadosOrdenados.map(item => item.revisado) },
                    { label: 'Não Autorizado', data: dadosOrdenados.map(item => item.naoAutorizado) },
                    { label: 'Desativado', data: dadosOrdenados.map(item => item.desativado) }
                ]
            }
            return {
                labels: debugData.labels,
                datasets: [
                    {
                        label: 'Instalado',
                        data: debugData.datasets[0].data,
                        borderColor: '#4CAF50',
                        backgroundColor: 'rgba(76, 175, 80, 0.1)',
                        fill: false
                    },
                    {
                        label: 'Pendente',
                        data: debugData.datasets[1].data,
                        borderColor: '#FF9800',
                        backgroundColor: 'rgba(255, 152, 0, 0.1)',
                        fill: false
                    },
                    {
                        label: 'Não se Instala',
                        data: debugData.datasets[2].data,
                        borderColor: '#F44336',
                        backgroundColor: 'rgba(244, 67, 54, 0.1)',
                        fill: false
                    },
                    {
                        label: 'Revisado',
                        data: debugData.datasets[3].data,
                        borderColor: '#2196F3',
                        backgroundColor: 'rgba(33, 150, 243, 0.1)',
                        fill: false
                    },
                    {
                        label: 'Não Autorizado',
                        data: debugData.datasets[4].data,
                        borderColor: '#FF5722',
                        backgroundColor: 'rgba(255, 87, 34, 0.1)',
                        fill: false
                    },
                    {
                        label: 'Desativado',
                        data: debugData.datasets[5].data,
                        borderColor: '#9E9E9E',
                        backgroundColor: 'rgba(158, 158, 158, 0.1)',
                        fill: false
                    }
                ]
            }
        },
        checkMessageNextStep() {
            messageNextStep = "Solicitar Analise"
        },
        async changeButtonName() {
            if (this.firestoreInstallation.revision) {
                const revision = this.firestoreInstallation.revision
                switch (revision.status) {
                    case 'approved':
                        if (this.isFranchisee){
                            this.readonlyScreen = true
                            this.disabledButtonNextStep = true
                            this.messageNextStep = `Waterfix Finalizado`
                        } else {
                            this.readonlyScreen = false
                            this.disabledButtonNextStep = true
                            this.messageNextStep = "Waterfix Finalizado"
                        }
                        break;
                    case 'requestedReview':
                        this.readonlyScreen = false
                        this.disabledButtonNextStep = false
                        if (this.isFranchisee) this.messageNextStep = "Enviar Revisão"
                        else{
                            this.disabledButtonNextStep = true
                            this.messageNextStep = "Aguardando Revisão"
                        }
                        break;
                    case 'reviewSent':
                        if (this.isFranchisee) {
                            this.readonlyScreen = true
                            this.disabledButtonNextStep = true
                            this.messageNextStep = "Aguardando Revisão"
                        }
                        else{
                            this.messageNextStep = "Finalizar Instalação"
                        }
                        break;
                    default:
                        if (this.isFranchisee){
                            this.readonlyScreen = true
                            this.disabledButtonNextStep = true
                             this.messageNextStep = "Aguardando Revisão"
                        } else {
                            this.readonlyScreen = false
                            this.disabledButtonNextStep = false
                            this.messageNextStep = "Finalizar Instalação"
                        }
                    break;
                }
            } else {
                this.messageNextStep = `Finalizar Instalação`
            }
        },
        openChoosePdfModal() {
            this.choosePdfModal = true;
            // Preencher pdfLocals com os locais disponíveis na instalação
            this.pdfLocals = (this.installationData || [])
              .map(item => ({ id: item.local, local: item.local }))
              .filter((v, i, a) => v.id && a.findIndex(t => t.id === v.id) === i);
        },
        closeChoosePdfModal() {
            this.choosePdfModal = false;
        },
        async downloadPdfModal() {
          this.pdfLoading = true;
          let requestParams = {
            projectId: this.idProject,
            term: this.pdfTermOption,
            local: this.pdfChosenOptionByTerm[this.pdfTermOption] === 'Geral' ? null : this.pdfChosenLocalByTerm[this.pdfTermOption],
            signature: false,
          };
          let request = this.pdfTermOptions.find((item) => item.id === this.pdfTermOption).request;
          try {
            const response = await request('Instalação', requestParams);
            this.pdfFileLink = response.data.signedUrl;
            this.pdfDialogDownload = true;
          } catch (e) {
            console.error(e);
            showErrorSnackBar('Ocorreu um erro interno na geração do PDF');
          }
          this.closeChoosePdfModal();
          this.pdfLoading = false;
        },
    },

    watch: {
        installationData: {
            handler(newVal) {
                // Força a reatualização dos computed properties quando os dados mudam
                this.$forceUpdate()
                // Atualiza o gráfico
                this.$nextTick(() => {
                    this.initializeTimelineChart()
                })
            },
            deep: true
        }
    },

    async created() {
        try {
            const [status, project] = await ProjectsService.getProjectById(this.idProject);
            this.project_data = project;
            // Carrega a preferência do usuário para visibilidade dos KPIs
            const savedKpisVisibility = localStorage.getItem('installation_kpis_visible');
            if (savedKpisVisibility !== null) {
                this.showKpis = savedKpisVisibility === 'true';
            }
            
            this.idInstallationLocal = this.idInstallation
            // Fecha a conexão existente se houver
            if (this.db) {
                this.db.close();
            }

            // Usa a função openDatabase que já tem a lógica correta de criação
            this.db = await openInstallationsDatabase();

            this.loading = true;
            if (this.idInstallationLocal && typeof this.idInstallationLocal === 'string') {
                try {
                    this.loading = true; // Ativa loading antes da chamada
                    this.loadingMessage = "Carregando dados da instalação...";
                    let { installation, items } = await InstallationService.getInstallationById(this.idInstallationLocal)

                    if (installation && installation.consumptionHistoric) {
                        //Cria a nova estrutura de subcoleção para os waterfix antigos
                        console.log("Estrutura antiga identificada!")
                        console.log("Atualizando estrutura para subcoleção...")
                        this.loadingMessage = "Atualizando estrutura de dados...";
                        items = await InstallationService.createInstallationSubCollection(installation.consumptionHistoric, installation.id_doc);
                        await InstallationService.updateInstallationWithDeleteConsumptionHistoric(installation.id_doc);
                    }

                    this.firestoreInstallation = installation
                    this.installationData = cloneDeep(items);
                    
                    this.revisionStatus = installation.revision?.status || ''
                    this.revisionObservation = installation.revision?.observation || ''
                } catch (error) {
                    console.error('Error during legacy installation:', error);
                } finally {
                    this.loading = false; // Desativa loading após a chamada
                }
            } else {
                this.idInstallationLocal = null
            }
            await this.checkIndexedDB();
            // Inicializa o gráfico após carregar os dados
            this.initializeTimelineChart()
            this.changeButtonName()
        } catch (error) {
            console.error("Error initializing database:", error);
            showErrorSnackBar("Erro ao inicializar o banco de dados local");
                    } finally {
                this.loading = false;
            }
            
            // Carrega os dados das soluções para conversão de IDs
            await this.loadSolutionsData();
            
        },
        beforeDestroy() {
            // Limpa o gráfico ao destruir o componente
            if (this.timelineChart) {
                this.timelineChart.destroy()
            }
        }
};